angular.module('examgen.directive').
directive('itemBrowserItem',function(){
  return function(scope,el,attr){
    /*
    scope.$watch('item.focused',function(newValue){
        if(newValue) el[0].scrollIntoView();        //TODO: added behaviour to scroll item into view when focused
    });
    */
  };
});